import React, { Component } from "react";
import { Modal, Button, textarea } from "react-bootstrap";
import { hastusUpdateAction,hideModalAction,actErrorAction } from '../actions/index';
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import './common/updatePopup.css';
import moment from 'moment'


class UpdatePopup extends React.Component {

    constructor(props) {
        super(props);
       // this.updateData = this.updateData.bind(this);
        this.state = {
            utime: '',
            udate: '',
            user: '',
            dempId: '',
            hid: '',
            signonerror : '',
            signofferror:''
        };
      }
    componentDidMount(){
      var workday = this.props.workdays.find(x => x.id == this.props.workday_id_manual);
      
      if(workday){
        this.setState({
          utime: moment(workday.updated_time,["h:mm A"]).format('HH:mm'),
          udate: moment(workday.updated_date).format('YYYY-MM-DD'),
          user: workday.lst_updt_user,
          dempId: workday.demp_display_Id,
          hid: workday.id,
          signonerror : workday.signin_error_message?workday.signin_error_message.replace(/"/g,''):'',
          signofferror:workday.signout_error_message?workday.signout_error_message.replace(/"/g,''):''
        })
      }
    }
    onChange(e) {
        this.setState({
            [e.target.name]: e.target.value
        })
    }
    // closing error box
    oncloseErrPop() {
      this.props.onActErr(false, true);  // para1: errpop, para2: acterr
    }
    updateData() {
      var hastusTime = this.state.utime;
      var hastusUser = this.state.user;
      var hastusDate = this.state.udate;
      var hastusdempId = this.state.dempId;
      var hastusId= this.state.hid;
      this.props.hastusUpdate(hastusId, hastusdempId, hastusUser, hastusTime, hastusDate);  
    }
    renderUpdateModal() {
      return (
        <Modal
          show={this.props.showModal}
          onHide={() => this.props.hideModal()} >
          <Modal.Header closeButton>
            <div className="cmt-modal-header">
              <span>{this.props.text}</span>
            </div>
          </Modal.Header>
          <div className={!this.props.activityErrPopup ? ( "hidden" ) : ( "errAlertDiv alert alert-danger fade in alert-dismissable")}>
            <a className="close" onClick={() => this.oncloseErrPop()} data-dismiss="alert"
                aria-label="close" title="close" >×
            </a>
            <strong>Error!</strong> {this.props.activityErrMessage}
          </div>
          <Modal.Body>
            <div className='showpopup'>
              <b> User:</b><input type="text" name="user" className="form-control mb-2 mr-sm-2" value={this.state.user} onChange={(e)=>this.onChange(e)} disabled/><br/>
              <b>Sign In Error Message:</b><br/>
              <textarea className = 'textareamsg' rows="4"  value={this.state.signonerror} /><br/>
              <b>Sign Out Error Message:</b><br/>
              <textarea className = 'textareamsg' rows="4"  value={this.state.signofferror} /><br/>
              <b>Updated Time:</b><input type="time" name="utime" className="form-control mb-2 mr-sm-2" value={this.state.utime} onChange={(e)=>this.onChange(e)} required/><br/>
              <b>Updated Date:</b><input type="date" name="udate" className="form-control mb-2 mr-sm-2" value={this.state.udate} onChange={(e)=>this.onChange(e)} required/><br/>
            </div>
          </Modal.Body>
          <Modal.Footer>
            <div>
              <button className="btn btn-primary" name= "rawData" onClick={(e)=>this.updateData(e)}>Update</button> 
              <button className="btn btn-danger" onClick={() => this.props.hideModal()}>Cancel</button>
            </div>
          </Modal.Footer>
        </Modal>
      );
    }
    render() {
      return this.renderUpdateModal();
    }
  }
function mapStateToProps(state) {
  
  return {
    workdays: state.workdays.workdays,
    showModal: state.modals.showModal,
    workday_id_manual : state.modals.workday_id_manual,
    activityErrPopup: state.modals.activityErrPopup,
    activityErrMessage: state.modals.activityErrMessage
  };
}
function matchDispatchToProps(dispatch) {
    return bindActionCreators(
        {
          hideModal: hideModalAction,
          hastusUpdate:hastusUpdateAction,
          onActErr: actErrorAction
        }, dispatch);
}

  export default connect(mapStateToProps,matchDispatchToProps)(UpdatePopup);
